export const MESSAGES_CONNECTIONS_SEARCH_INTERACTION_CLASS =
  'shepherd-messages-connections-search-interaction';

export function setMessagesConnectionsSearchInteractionActive(active: boolean): void {
  document.body.classList.toggle(MESSAGES_CONNECTIONS_SEARCH_INTERACTION_CLASS, active);
}

export function resolveMessagesConnectionsSearchTarget(): HTMLElement | null {
  return document.querySelector('[data-tour="messages-connections-search"]');
}

export function resetMessagesConnectionsSearchTargetPadding(): void {
  const root = resolveMessagesConnectionsSearchTarget();
  if (root) {
    root.style.paddingBottom = '';
  }
}
